import { site } from '@/data/site';

/**
 * Persistent chrome below Contact, not a numbered section.
 *
 * Social links are plain text in the same `label` treatment as every other
 * link on the site. Introducing icons here and nowhere else would break the
 * purely typographic grammar the other eight sections establish — the reason
 * `lucide-react` was removed from the project entirely in v6 Phase 5.
 *
 * The build line is real, verifiable provenance from `vite.config.ts`'s git
 * hash and date — the same "provenance as content" idea as the fork credits
 * on the specimen cards, and specifically not a fabricated stat.
 */
export function Footer() {
  return (
    <footer className="border-edge border-t px-(--gutter) py-10">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <ul className="flex flex-wrap gap-x-6 gap-y-2">
          {site.socials.map((social) => (
            <li key={social.id}>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="label text-bone hover:text-acid transition-colors"
              >
                {social.label}
                {/* `text-muted`, not `text-edge`. --color-edge is 1.33:1 and is
                    for decorative rules only — using it for text here was
                    caught by Lighthouse as a real contrast failure, which is
                    exactly what the rule in docs/DESIGN-V7.md §2 predicts. */}
                {social.handle && <span className="text-muted"> {social.handle}</span>}
              </a>
            </li>
          ))}
        </ul>

        <div className="md:text-right">
          <p className="label">
            Build <span className="text-bone">{__BUILD_HASH__}</span> · {__BUILD_DATE__}
          </p>
          <p className="label mt-2">
            © {new Date().getFullYear()} {site.name}
          </p>
        </div>
      </div>
    </footer>
  );
}